import { useState } from "react";
import useAgenda from "../../hooks/useAgenda";
import {formatarNomeUpper, formatarData} from "../../utils/formatadores"

const ConsultarAgenda = () => {
  // Define "pendente" como padrão ao carregar a tela
  const [filtro, setFiltro] = useState("pendente");
  const { agenda, carregarAgenda, deletarCompromisso, concluirCompromisso } = useAgenda(filtro);

  const handleMudarFiltro = (novoFiltro) => {
    setFiltro(novoFiltro);
    carregarAgenda(novoFiltro);
  };

  const alternarFiltroColuna = (tipo) => {
    const proximoFiltro = filtro === tipo ? "todos" : tipo;
    handleMudarFiltro(proximoFiltro);
  };

  const calcularDias = (data) => {
    if (!data) return null;
    const hoje = new Date();
    const prazo = new Date(data);

    hoje.setHours(0, 0, 0, 0);
    prazo.setHours(0, 0, 0, 0);

    const diff = prazo - hoje;
    return Math.ceil(diff / (1000 * 60 * 60 * 24));
  };

  const agendaComDias = agenda.map((item) => {
    const dataRef =
      item.dataManifestacao || item.dataAudiencia || item.dataPrazo;

    return {
      ...item,
      dias: calcularDias(dataRef)
    };
  });

  const agendaOrdenada = [...agendaComDias].sort(
    (a, b) => (a.dias ?? 9999) - (b.dias ?? 9999)
  );

  const prazosVencidos = agendaOrdenada.filter((p) => p.dias < 0).length;
  const prazosVincendos = agendaOrdenada.filter(
    (p) => p.dias >= 0 && p.dias <= 10
  ).length;

  const classePrazo = (dias) => {
    if (dias === null) return "";
    if (dias < 0) return "prazo-vencido";
    if (dias <= 10) return "prazo-vincendo";
    return "";
  };

  return (
    <div className="container-consulta-processos">
      <div className="card">
        <div className="agenda-header">
          <h1>AGENDA DE COMPROMISSOS</h1>
        </div>

        <hr/>

        <div className="agenda-indicadores">
          <div className="indicador">
            <h3>Vencidos</h3>
            <span>{prazosVencidos}</span>
          </div>

          <div className="indicador">
            <h3>Vencem em 10 dias</h3>
            <span>{prazosVincendos}</span>
          </div>

          <div className="indicador">
            <h3>Total Exibido</h3>
            <span>{agendaOrdenada.length}</span>
          </div>

          {/* SELECT COM VALOR PADRÃO PENDENTE */}
          <div className="indicador select-container">
            <h3>Filtrar por</h3>
            <select
              value={filtro}
              onChange={(e) => handleMudarFiltro(e.target.value)}
              className="select-filtro"
            >
              <option value="pendente">Pendentes (Padrão)</option>
              <option value="concluido">Concluídos</option>
              <option value="audiencia">Audiências</option>
              <option value="manifestacao">Manifestações</option>
              <option value="todos">Todos os registros</option>
            </select>
          </div>
        </div>

        <div className="table-container">
          <table className="table">
            <thead>
              <tr>
                <th>Colaborador executor</th>
                <th>Tipo</th>
                <th>Processo</th>
                <th>Parte</th>
                <th
                  style={{ cursor: "pointer" }}
                  onClick={() => alternarFiltroColuna("audiencia")}
                >
                  Audiência {filtro === "audiencia" && "▲"}
                </th>
                <th
                  style={{ cursor: "pointer" }}
                  onClick={() => alternarFiltroColuna("manifestacao")}
                >
                  Manifestação {filtro === "manifestacao" && "▲"}
                </th>
                <th>Realizar tarefa</th>
                <th>Descrição</th>
                <th
                  style={{ cursor: "pointer" }}
                  onClick={() => alternarFiltroColuna("pendente")}
                >
                  Status {filtro === "pendente" && "▲"}
                </th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {agendaOrdenada.length > 0 ? (
                agendaOrdenada.map((item) => (
                  <tr
                    key={item._id}
                    className={`row-hover cursor-pointer ${classePrazo(item.dias)}`}
                  >
                    <td>{formatarNomeUpper(item.colaboradorExecutor) || "-"}</td>
                    <td>{item.tipo}</td>
                    <td>
                      {typeof item.processoId === "object"
                        ? item.processoId?.numeroProcesso || "-"
                        : item.processoId || "-"}
                    </td>
                    <td>{formatarNomeUpper(item.nomeParte) || "-"}</td>
                    <td>{formatarData(item.dataAudiencia) || "-"}</td>
                    <td>{formatarData(item.dataManifestacao) || "-"}</td>
                    <td>{formatarData(item.colaboradorPrazoExecutar) || "-"}</td>
                    <td>{item.descricao}</td>
                    <td>
                      {item.status === "concluido" ? "Concluído" : "Pendente"}
                    </td>
                    <td className="acoes-cell">
                      <div className="acoes-group">
                        {item.status !== "concluido" && (
                          <button
                            className="btn-action btn-check"
                            onClick={(e) => {
                              e.stopPropagation();
                              concluirCompromisso(item._id);
                            }}
                            title="Concluir compromisso"
                            aria-label="Concluir compromisso"
                          >
                            ✓
                          </button>
                        )}
                        <button
                          className="btn-action btn-delete"
                          onClick={(e) => {
                            e.stopPropagation();
                            deletarCompromisso(item._id);
                          }}
                          title="Excluir processo"
                          aria-label="Excluir processo"
                        >
                          🗑
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10" className="text-center empty-cell">
                    Nenhum compromisso encontrado.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ConsultarAgenda;